import { DesktopNavigationMenuProps, GlobalNavigationBar, MenuNavigationItem, MenuNavigationItemTypeItem, MobileNavigationMenuProps, SystemIcons } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { Brasil, USA } from './Flags';
import { useEffect, useState } from 'react';
import { selectLocale, selectMarket } from '../store/slices/globalConfigSlice';
import { useSelector } from 'react-redux';
import { selectGigyaAccount, selectIsAuthenticated, selectUserProfile } from '../store/slices/userSlice';
import { ProfileComponent } from "@laerdal/navigation"
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { t, i18n } = useTranslation('translation');
  const [desktopMenu, setDesktopMenu] = useState<DesktopNavigationMenuProps>();
  const [mobileMenu, setMobileMenu] = useState<MobileNavigationMenuProps>();
  const currentLocale = useSelector(selectLocale);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const account = useSelector(selectGigyaAccount);
  const user = useSelector(selectUserProfile);
  const currentMartket = useSelector(selectMarket);
  const navigate = useNavigate()



  useEffect(() => {
    var signedInConfig = {
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],
      buttons: [
        {
          type: 'profile'
        },
        {
          type: 'switcher',
          action: () => { window.globalNav?.show(); }
        },
      ],
      action: {
        label: t('Dashboard'),
        action: () => { window.location.href = process.env.REACT_APP_CONNECT_LINK ?? '' }
      },
    } as DesktopNavigationMenuProps;

    var unauthorizedConfig = {
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],
      action: {
        action: () => {
          // @ts-ignore
          window.gigya.sso.login({
            authFlow: 'redirect',
            redirectURL: window.location.href,
            useChildContext: true,
            context: {
              application: 'Support',
              lng: i18n.language
            }
          });
        },
        label: t('Login'),
      }
    } as DesktopNavigationMenuProps;


    setDesktopMenu(!!user ? signedInConfig : unauthorizedConfig);

    setMobileMenu({
      items: [
        {
          label: t('Support Home'),
          to: '/',
          exact: true
        }
      ],

    });
  }, [i18n.language, currentLocale, isAuthenticated, account, user]);


  useEffect(() => {
    
    if (process.env.REACT_APP_NEW_NAVIGATION?.toString() != 'true')
      return;

//@ts-ignore
    window.laerdal.navigation.init({
        onLogout: () => {
          //@ts-ignore
          window.gigya.accounts.logout();
        },
        onLogin: () => {
          //@ts-ignore
          window.gigya.sso.login({
            authFlow: 'redirect',
            redirectURL: window.location.href,
            useChildContext: true,
            context: {
              application: 'Support',
              lng: i18n.language
            }
          });
        },
        menu: [{
          type: 'item',
          id: 'dashboardLink',
          label: t('Support Home'),
          to: '/',
          exact: true,
          active: '/' === location.pathname,
          action: () => {
            navigate(`/${currentMartket}`);
          },
        }],
        locale: i18n.language ?? 'en',
        market: !currentMartket ? 'en' : currentMartket
        
    })
    //@ts-ignore
    window.laerdal.navigation.changeMarket(!currentMartket ? 'en' : currentMartket)
    
    //@ts-ignore
    if(window.laerdalGlobalNav?.onUpdateMarket)
    {
      //@ts-ignore
      window.laerdalGlobalNav?.onUpdateMarket(!currentMartket ? 'en' : currentMartket);
    }
  }, [i18n.language, currentMartket, user]);

  return (
    <>
      
        <>
          {/* @ts-ignore */}
          <laerdal-global-navigation-bar 
          showcart="true" 
          showshopurl="true"/>
        </>
      
    </>
  );
}

export default Header;

function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}
